module.exports = __webpack_public_path__ + "static/img/暂无配送地址icon@2x@2x.e7c26ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/购物车/暂无配送地址icon@2x@2x.png
// module id = dmG2
// module chunks = 192